import * as React from 'react';
// @ts-expect-error
import type {RouterHistory} from 'react-router-dom';

import type {ReportGridItemType} from '../../../../../ui/reports/overview/default-reports/types';
import {getReportIcon} from '../../../../../ui/reports/report-constants';
import type {ReportKey} from '../../../../../ui/reports/report-types';

import {FeatureCard} from '../ai-homepage/ai-feature-card/feature-card';
import type {CueCardCta} from '../cue-card/cue-card';

type Props = {
    title: string;
    description: string;
    history: RouterHistory;
    exploreLink?: string;
    thumbnailIllustration?: string;
    reportType: ReportGridItemType;
    cta?: CueCardCta;
};

/**
 * A card component for displaying default reports on the reports overview page.
 */
export function DefaultReportCard(props: Props) {
    const thumbnailBackgroundColor = props.thumbnailIllustration ? 'blueXlt' : undefined;
    const thumbnailBackgroundColorHover = props.thumbnailIllustration ? 'blueLt' : undefined;
    const thumbnailBackgroundGradientHover = props.thumbnailIllustration
        ? {colors: ['blueLt', 'reportBlue'], angle: 180}
        : undefined;

    return (
        <FeatureCard
            title={props.title}
            description={props.description}
            history={props.history}
            exploreLink={props.exploreLink}
            // @ts-expect-error
            thumbnail={
                props.thumbnailIllustration
                    ? {
                          backgroundColor: thumbnailBackgroundColor,
                          backgroundColorHover: thumbnailBackgroundColorHover,
                          backgroundGradientHover: thumbnailBackgroundGradientHover,
                          illustration: props.thumbnailIllustration,
                      }
                    : undefined
            }
            icon={
                props.reportType === 'email-digests'
                    ? undefined
                    : getReportIcon(props.reportType as ReportKey)
            }
            variant='feature'
            cta={props.cta}
        />
    );
}
